import React from 'react';
import { useIntl } from 'react-intl';

import { Event } from 'app/shared/typings';
import { Divider } from 'app/shared/components/atoms';
import { Box, Typography } from 'app/shared/components/atoms';
import {
  ButtonsSectionProps,
  ModalButtonsSection,
} from 'app/shared/components/molecules';
import { calcMaxTicketsCanPurchase } from 'app/fan/utils/checkout';
import { useEventPageContext } from 'app/fan/context/EventPage';
import { TicketQuantityStepper } from 'app/fan/components/molecules';
import { TermsAndConditionsSummaryRow } from 'app/fan/components/pages/Event/components';

import { ApplyFlowCheckoutWidgetWrapper } from './Wrapper';

interface Props extends ButtonsSectionProps {
  event: Event;
  numberOfTickets: number;
  setNumberOfTickets: React.Dispatch<React.SetStateAction<number>>;
}

export const ApplyFlowCheckoutWidget: React.FC<
  React.PropsWithChildren<Props>
> = ({
  event,
  numberOfTickets,
  setNumberOfTickets,
  ...modalButtonsSectionProps
}) => {
  const { formatMessage } = useIntl();
  const { eventAttendee } = useEventPageContext();
  const maxTickets = calcMaxTicketsCanPurchase(event, eventAttendee);

  return (
    <ApplyFlowCheckoutWidgetWrapper>
      <Box mb={8}>
        <Typography
          fontSize="fontSize500"
          fontWeight="medium"
          fontFamily="title"
        >
          {formatMessage({ id: 'event.checkout.expressCheckoutTitle' })}
        </Typography>
      </Box>
      <Box justifyContent="space-between" alignItems="center" w="100%" gap={4}>
        <Box justifyContent="left" flexDirection="column">
          <Box flexDirection="row">
            <Typography fontWeight="medium">
              {formatMessage({ id: 'checkout.tickets' })}
            </Typography>
          </Box>
        </Box>
        <Box
          justifyContent="flex-end"
          alignItems="flex-end"
          alignContent="center"
          py={2}
        >
          <TicketQuantityStepper
            data-qaid="shopping-cart-ticket-quantity-stepper"
            numberOfTickets={numberOfTickets}
            setNumberOfTickets={setNumberOfTickets}
            maxTickets={maxTickets}
            disabled={modalButtonsSectionProps.isPrimaryCtaDisabled}
          />
        </Box>
      </Box>
      <Divider my={8} />
      <ModalButtonsSection {...modalButtonsSectionProps} />
      <Box flexDirection="row" justifyContent="flex-end">
        <TermsAndConditionsSummaryRow />
      </Box>
    </ApplyFlowCheckoutWidgetWrapper>
  );
};
